module.exports = __webpack_public_path__ + "img/contact-active.7c017716.svg";